import useWindowSize from './useWindowSize';

interface Props {
  breakpoint?: number;
}

const useDesktopSize = ({ breakpoint = 740 }: Props = {}): boolean => {
  const { width } = useWindowSize();

  return width > breakpoint;
};

export default useDesktopSize;
